<template>
  <div class="animated fadeIn">
    <button
      type="button"
      @click="OpenModal"
      class="btn btn-success mr-2"
      title="Salva os dados do GAAU e adiciona os dados antigo no histórico"
    >
      Salvar/Criar Histórico
    </button>
    <b-modal
      v-model="modal"
      title="Você confirma a criação de histórico do GAAU?"
      class="modal-danger"
      ok-variant="success"
      @ok="ModalOk"
    >
      <div class="form-group">
        <label for>Deseja atualizar a data? </label>
        <input
          v-model="date"
          class="form-control"
          type="date"
          placeholder="Digite a data"
        />
      </div>
    </b-modal>
  </div>
</template>
      
      <script>
import RotateSquare from "../../components/RotateSquare";
import GaauService from "../../servico/GaauService";

export default {
  name: "SaveHistoryGaauButton",
  components: {
    RotateSquare,
    GaauService
  },
  props: {
    action: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      modal: false,
      date: null
    };
  },

  mounted() {
    this.modal = false;
  },
  methods: {
    OpenModal() {
      this.modal = true;
    },
    ModalOk() {
      if (this.action) this.action(this.date);

      this.modal = false;
    }
  }
};
</script>
      